import React from 'react';
import './RetailDistributionApproachSection.css';

function RetailDistributionApproachSection() {
  const approaches = [
    {
      title: 'Responsible Distribution',
      description: 'We maintain strict quality control and brand integrity across all distribution channels, ensuring products reach the market through legitimate, authorized pathways.'
    },
    {
      title: 'Accurate Product Representation',
      description: 'Complete product documentation, compliance verification, and accurate channel-specific product information to support successful market placement and consumer satisfaction.'
    },
    {
      title: 'Reliable Fulfillment Coordination',
      description: 'Professional order coordination, logistics management, and inventory tracking across distribution partners to ensure consistent, timely product delivery.'
    },
    {
      title: 'Long-Term Partnerships',
      description: 'Strategic supplier relationships built on transparency, mutual growth, and sustainable business practices that support suppliers throughout their distribution lifecycle.'
    }
  ];

  return (
    <section id="retail-distribution" className="retail-distribution-section">
      <div className="section-container">
        <div className="retail-distribution-header">
          <h2>Retail Distribution Approach</h2>
          <p className="retail-distribution-intro">
            Northstar Bridge Commerce LLC supports selected consumer product lines through online retail, marketplace, and partner-based distribution channels in the United States. Our approach focuses on responsible distribution, accurate product representation, reliable fulfillment coordination, and long-term supplier relationships.
          </p>
        </div>

        <div className="retail-distribution-grid">
          {approaches.map((approach, index) => (
            <div key={index} className="approach-card">
              <div className="approach-number">{index + 1}</div>
              <h3>{approach.title}</h3>
              <p>{approach.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default RetailDistributionApproachSection;
